var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.208.008C21.276.008 24 2.866 24 7.118v9.815c0 4.24-2.724 7.097-6.792 7.097H6.804C2.736 24.03 0 21.173 0 16.933V7.118C0 2.866 2.736.008 6.804.008h10.404zM15.612 8.38a1.055 1.055 0 00-1.488 0L12 10.517 9.864 8.381c-.42-.41-1.08-.41-1.488 0a1.058 1.058 0 000 1.488l2.136 2.14-2.136 2.125a1.058 1.058 0 00.744 1.802c.276 0 .54-.11.744-.314L12 13.498l2.136 2.124a.987.987 0 00.732.314c.276 0 .54-.11.744-.314a1.043 1.043 0 000-1.476l-2.136-2.138 2.136-2.14a1.058 1.058 0 000-1.487z"
  })));
}

export default __webpack_public_path__ + "a165ba1fb0bc569312f49076f9108572.svg";
export { SvgClose as ReactComponent };